import { useEffect } from 'react';
import { useNotifications } from '../../contexts/NotificationContext';

const NotificationHelper = () => {
  const { notify } = useNotifications();

  useEffect(() => {
    // Expose notification helpers to window for development debugging only
    if (process.env.NODE_ENV === 'development') {
      window.__notificationHelpers = notify;

      return () => {
        delete window.__notificationHelpers;
      };
    }
  }, [notify]);

  return null;
};

export default NotificationHelper; 